<template>

  <div class="container mol-typical-page-container-20" :class="{'showing-message-banner': false}">

    <LoadingSpinner class="loading-spinner" v-if="!clubInfoArray"></LoadingSpinner>

    <div v-else class="row">

      <div v-if="show_clubs_description" class="row">
        <div class="col-12 mol-color-theme-oscar-pool clubs-description">
          <p><b>An Oscar Pool lets you compete with family, friends, coworkers, etc.</b></p>
          <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Guess which nominees will be winners.</p>
          <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Race to see who can watch the most nominated films.</p>
          <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Track results on your pool's private leaderboard.</p>
          <div class="mol-color-theme-oscar-pool rules-div">
            Want to learn more about Oscar Pools?<br>
            Check out our <router-link class="mol-subtle-link mol-internal-link" to="/oscar-pool/about">rules</router-link>.
          </div>
        </div>
      </div>

      <!--    create club card -->
      <div v-if="show_clubs_description" :class="show_wide_create_club_card? 'col-12' : 'col-lg-6'">
        <ClubCard_JoinClub></ClubCard_JoinClub>
      </div>

      <div v-if="show_clubs_description" class="separator-with-text">
        <span>OR</span>
      </div>

      <div v-if="club_creation_allowed" :class="show_wide_create_club_card? 'col-12' : 'col-lg-6'">
        <ClubCard_CreateClub></ClubCard_CreateClub>
      </div>


      <div v-for="clubInfo in clubInfoArray" :key="clubInfo.club._id" :class="show_wide_club_card? 'col-12' : 'col-lg-6'">
        <span v-if="clubInfo.markedForDeletion()" class="badge rounded-pill"><i class="fa fa-trash-o" aria-hidden="true"></i> pending deletion</span>
        <span v-else-if="clubInfo.pending()" class="badge rounded-pill"><i class="fa fa-hourglass-1" aria-hidden="true"></i> pending approval</span>
        <span v-else-if="clubInfo.club.pendingMemberCount" class="badge rounded-pill pulse"><i class="fa fa-hourglass-1" aria-hidden="true"></i> {{clubInfo.club.pendingMemberCount}} contestants awaiting approval</span>
        <span v-else-if="clubInfo.oscar_pool_to_launch" class="badge rounded-pill pulse"><i class="fa fa-sliders" aria-hidden="true"></i> set up scoring</span>
        <ClubCard
            :club="clubInfo.club"
            :my_membership="clubInfo.my_membership"
            @update-clubs-list="getMyClubs()"
        ></ClubCard>
      </div>

    </div> <!--row-->

    <div class="mol-color-theme-oscar-pool rules-div">
      Want to learn more about Oscar Pools?<br>
      Check out our <router-link class="mol-subtle-link mol-internal-link" to="/oscar-pool/about">rules</router-link>.
    </div>

  </div> <!--container-->
</template>


<script>
import ClubCard_CreateClub from "@/components/clubs/cards/ClubCard-CreateClub.vue";
import ClubCard_JoinClub from "@/components/clubs/cards/ClubCard-JoinClub.vue";
import ClubCard from "@/components/clubs/cards/ClubCard.vue";
import axios from "axios";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {userStore} from "@/userStore";

export default {
  name: "ClubsPage",
  components: {LoadingSpinner, ClubCard_CreateClub, ClubCard_JoinClub, ClubCard},
  data() {
    return {
      clubInfoArray: null,
      ceremonyState: null,
    }
  },
  computed: {
    userStore() {
      return userStore;
    },
    club_creation_allowed() {

      // clubs (oscar pools really) can only be created pre-ceremony
      if ( this.ceremonyState !== 'pre-ceremony' ) {
        return false;
      }

      // if the user is a member, or a user with no clubs, creation is allowed
      const memberOfNoClubs = this.clubInfoArray && (this.clubInfoArray.length === 0);
      if ( userStore.isFullMember() || memberOfNoClubs ) {
        return true;
      }

      return false;
    },
    show_clubs_description() {
      // if there are NO club cards, show our description
      return this.clubInfoArray && (this.clubInfoArray.length === 0);
    },
    show_wide_create_club_card() {
      // show the invite card wide if we're showing the description.
      return this.show_clubs_description;

      // experimented with showing a wide invite card if there were an even number of friends, so the bottom would always be full.
      //return ( this.confirmed_friends.length % 2 === 0 );
    },
    show_wide_club_card() {
      // show the invite card wide if we're showing the description.
      return this.clubInfoArray && (this.clubInfoArray.length === 1) && !userStore.isFullMember();

      // experimented with showing a wide invite card if there were an even number of friends, so the bottom would always be full.
      //return ( this.confirmed_friends.length % 2 === 0 );
    },
  },

  async created() {
    return Promise.all([
      this.getMyClubs(),
      this.getCeremonyState()
    ]);
  },

  methods: {
    async getCeremonyState() {
      return axios.get("/api/club/oscar-pool/ceremony-state")
          .then(response => {
            this.ceremonyState = response.data.ceremonyState;
          });
    },
    async getMyClubs() {
      return axios.get('/api/club/my-clubs')
          .then(response => {
           // console.log(`GET /api/club/my-clubs`, response.data)
            this.clubInfoArray = response.data;

            // give each clubInfo a pending() method
            this.clubInfoArray.forEach(clubInfo => {
              clubInfo.pending = function() {
                return (this.my_membership?.role === 'pending');
              }
              clubInfo.markedForDeletion = function() {
                return !!this.club.marked_for_deletion;
              }

            });

            // sort clubs alphabetically by name
            this.clubInfoArray.sort((clubInfoA, clubInfoB) => {
              return (
                  ( clubInfoA.club.name.toLowerCase() < clubInfoB.club.name.toLowerCase() ) ? -1 :
                      ( clubInfoA.club.name.toLowerCase() > clubInfoB.club.name.toLowerCase() ) ? 1 :
                          0
              );
            });

            // then, sort again, putting the pending clubInfo elements last
            this.clubInfoArray.sort((clubInfoA, clubInfoB) => {
              return (
                  ( clubInfoA.pending() && !clubInfoB.pending() ) ? 1 :
                      ( clubInfoB.pending() && !clubInfoA.pending() ) ? -1 :
                        0
              );
            });

            // then, sort again, putting the markedForDeletion clubInfo elements last
            this.clubInfoArray.sort((clubInfoA, clubInfoB) => {
              return (
                  ( clubInfoA.markedForDeletion() && !clubInfoB.markedForDeletion() ) ? 1 :
                      ( clubInfoB.markedForDeletion() && !clubInfoA.markedForDeletion() ) ? -1 :
                          0
              );
            });

          })
          .catch(err => {
            console.log(err);
          })
    }
  }
}
</script>


<style scoped>

.mol-typical-page-container-20 {
  padding-bottom: 50px;
}

.clubs-description {
  padding-bottom: 30px;
  text-align: center;
  font-size: x-large;
  b {
    margin-bottom: 2em;
  }
  border-style: none none solid none;
}

.badge {
  background-color: var(--bs-danger);
  position: absolute;
  margin-top: 12px;
  margin-left: 12px;
  z-index: 1;
  i {
    font-size: x-small;
  }

  &.pulse {
    animation: pulse-animation 2s infinite;
  }

}

.loading-spinner {
  margin-top: 100px;
}

@keyframes pulse-animation {
  0% { box-shadow: 0 0 0 0px rgba(255, 127, 80, 0.4); }
  100% { box-shadow: 0 0 0 15px rgba(255, 127, 80, 0); }
}

.rules-div {
  text-align: center;
  margin-top: 50px;
  font-size: 1rem;
}

.or-text {
  text-align: center;
}

.separator-with-text {
  color: var(--mol-color-gold-text);

  display: flex;
  align-items: center; /* Centers the items vertically */
  text-align: center;
  /*border-bottom: 1px solid #ccc; !* Optional: Fallback line for older browsers *!*/
  line-height: 1em; /* Ensures the line is aligned with the text height */
  margin: 0 0 2em 0; /* Provides some vertical spacing */
}

.separator-with-text::before,
.separator-with-text::after {
  content: '';
  flex: 1; /* Allows the lines to fill the remaining space */
  border-bottom: 1px solid var(--mol-color-gold-faded);
  margin: 0 0.5em; /* Spacing between the text and the lines */
}


</style>